$ = jQuery.noConflict()

$(document).ready(function () {
  function addCarousel(element, index, number, mover, margin, itemstablet, loop, flechas, dots, autoplay, velocidad, animateIn, animateOut, autoWidth, slideBy, autoWidthMobile, margindesktop, URLhashListener, dotsContainer, itemsMobile) {
    $('.' + element + '.owl-carousel').owlCarousel({
      loop: loop,
      margin: margin,
      nav: flechas,
      dots: dots,
      dotsContainer: dotsContainer || false,
      autoplay: autoplay,
      mouseDrag: mover,
      startPosition: index,
      autoplayTimeout: velocidad || 3000,
      animateOut: animateOut,
      animateIn: animateIn,
      autoWidth: autoWidthMobile,
      items: number,
      slideBy: slideBy || 1,
      URLhashListener: URLhashListener,
      autoplayHoverPause: true,

      responsive: {
        0: {
          items: itemsMobile || 1,
          mouseDrag: false,
          autoWidth: autoWidthMobile,
          slideBy: itemsMobile ? slideBy || 1 : 1,
          URLhashListener: URLhashListener,
        },
        600: {
          items: itemstablet,
          mouseDrag: false,
          autoWidth: autoWidth,
          margin: margindesktop,
          slideBy: slideBy || 1,
          URLhashListener: URLhashListener,
        },
        1000: {
          items: itemstablet,
          autoWidth: autoWidth,
          margin: margindesktop,
          slideBy: slideBy || 1,
          URLhashListener: URLhashListener,
        },
      },
    })
  }

  addCarousel('hero-service__hero', 'URLHash', 1, true, 0, 1, false, false, false, false, 3000, '', '', false, false, false, 0, true)
  addCarousel('clients__items', 0, 1, true, 16, 4, true, true, false, true, 3000, '', '', false, false, false, 32)
  addCarousel('hero-container', 0, 1, true, 0, 1, true, true, false, true, 5000)
  addCarousel('team__carousel', 0, 2, true, 0, 5, true, true, false, false, 3000, '', '', true, false, false, 0, false)
  addCarousel('success-stories__content', 0, 1, true, 32, 3, false, false, false, false, 3000, '', '', false, 4, false, 40)
  addCarousel('header-principal__text__carousel', 0, 1, true, 0, 1, true, false, false, true, 4000)
  addCarousel('product-track', 0, 1, true, 0, 3, true, false, false, true, 4000, '', '', true, 1, false, 48)
  addCarousel('clients-section__track', 0, 3, true, 28, 3, true, false, true, false, 3000, '', '', false, 1, false, 28, false, '.clients-section__pagination', 1)
  // slideBy 3 → arrows advance a full page of 3 (matching the dots) on tablet/desktop;
  // the 0-breakpoint forces slideBy 1 (one item) on mobile.
  addCarousel('sector-carousel', 0, 1, true, 24, 3, true, false, true, false, 3000, '', '', false, 3, false, 24, false, '.sector-carousel__dots')
  // Press "Presencia en medios" — 3-up desktop / 1 mobile, custom prev/next arrows.
  addCarousel('press-track', 0, 3, true, 24, 3, true, false, false, false, 3000, '', '', false, 1, false, 24)
  // Expertos en video (>3 videos) — 3-up desktop / 1 mobile, dots + flechas como sector.
  addCarousel('expertos-videos-carousel', 0, 1, true, 24, 3, true, false, true, false, 3000, '', '', false, 3, false, 24, false, '.expertos-videos__dots')

  $('[data-owl-prev], [data-owl-next]').on('click', function () {
    const $button = $(this)
    const target = $button.data('owl-prev') || $button.data('owl-next')
    const direction = $button.data('owl-prev') ? 'prev.owl.carousel' : 'next.owl.carousel'

    if (!target) return

    $(target).trigger(direction)
  })

  if (window.matchMedia('(min-width: 900px)').matches) {
    $('.hero-service__buttons').addClass('owl-carousel owl-theme')
    addCarousel('hero-service__buttons', 0, 3, true, 0, 5, false, true, false, false, 4000, '', '', false, 5, false, 20, false)
  }
})
